import * as React from 'react';
import styles from './index.less';
import FNoDataTip from '@/components/FNoDataTip';
import { history } from '@@/core/history';
import { FUtil, FI18n } from '@freelog/tools-lib';

interface Error403Props {

}

function Error403({}: Error403Props) {
  return (<div>
    <FNoDataTip
      height={'calc(100vh - 70px)'}
      tipText={FI18n.i18nNext.tAuto('msg_resource_status_prepareforrelease')}
      btnText={'将前往首页'}
      onClick={() => {
        history.replace(FUtil.LinkTo.market());
      }}
    />
  </div>);
}

export default Error403;
